import React from 'react'

const ReturnCustomComp = ({ returnCustomComp }) => <>{returnCustomComp?.children}</>;

export { ReturnCustomComp };
